const MARKDOWN_BLOCK = /^\s*(#{1,6}\s|[-*+]\s|\d+[.)]\s|>|([-*_])\2{2,}\s*$)/m;

/**
 * Product descriptions are authored either as Markdown or as plain lines
 * ("$1600 / team\n12 games\nJerseys included"). Markdown is passed through;
 * plain text becomes Markdown where each multi-line paragraph is a bullet list,
 * so line breaks aren't lost when rendered.
 */
export function toProductMarkdown(text) {
  const source = String(text ?? "").replace(/\r\n?/g, "\n").trim();
  if (!source) return "";
  if (MARKDOWN_BLOCK.test(source)) return source;
  return source
    .split(/\n\s*\n/)
    .map((para) => {
      const lines = para
        .split("\n")
        .map((l) => l.trim())
        .filter(Boolean);
      return lines.length > 1 ? lines.map((l) => `- ${l}`).join("\n") : lines[0] || "";
    })
    .filter(Boolean)
    .join("\n\n");
}

/** "Division 1 - COMDEV\nFall 2026" → { title: "Division 1 - COMDEV", subtitle: "Fall 2026" } */
export function splitProductName(name) {
  const [title, ...rest] = String(name ?? "")
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
  return { title: title || "", subtitle: rest.join(" · ") };
}
